<template>
  <!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In  -->
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="178.7px"
       height="175.33px" viewBox="0 0 178.7 175.33" style="enable-background:new 0 0 178.7 175.33;" xml:space="preserve">
<defs>
</defs>
    <path d="M166.7,33.33h-20.09l3.86-18.14c1.37-6.46-2.79-12.86-9.24-14.23l-3.26-0.69c-6.46-1.37-12.86,2.79-14.23,9.24l-5.06,23.83H83.14l3.86-18.14c1.37-6.46-2.79-12.86-9.24-14.23l-3.26-0.69C68.03-1.11,61.63,3.05,60.26,9.5l-5.06,23.83H30.5c-6.6,0-12,5.4-12,12v3.33c0,6.6,5.4,12,12,12h18.88l-11.48,54H12c-6.6,0-12,5.4-12,12V130c0,6.6,5.4,12,12,12h20.09l-3.86,18.14c-1.37,6.46,2.79,12.86,9.24,14.23l3.26,0.69c6.46,1.37,12.86-2.79,14.23-9.24L60.04,142h35.53l-3.86,18.14c-1.37,6.46,2.79,12.86,9.24,14.23l3.26,0.69c6.46,1.37,12.86-2.79,14.23-9.24l5.06-23.83h24.69c6.6,0,12-5.4,12-12v-3.33c0-6.6-5.4-12-12-12h-18.88l11.48-54h25.9c6.6,0,12-5.4,12-12v-3.33C178.7,38.73,173.3,33.33,166.7,33.33z M101.37,114.66H65.85l11.48-54h35.53L101.37,114.66z"/>
</svg>

</template>

<script>
export default {
  name: 'IconHashTag'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/svg/IconHashTag.vue